import { action } from 'typesafe-actions';

import { balanceTypes, balanceInterface, balanceTypeInterface } from './types';

// Get Balance
export const getBalanceRequest = (payload: object) =>
  action(balanceTypes.GET_BALANCE_REQUEST, payload);

export const getBalanceSuccess = (payload: {
  balanceList: balanceInterface;
  totalCount: number;
}) => action(balanceTypes.GET_BALANCE_SUCCESS, payload);

export const getBalanceFailure = () => action(balanceTypes.GET_BALANCE_FAILURE);

// Get Balance
export const walletDebitRequest = (payload: {
  value: number;
  walletChargeId: string;
  description: string;
  data: null;
  userId: string;
}) => action(balanceTypes.WALLET_DEBIT_REQUEST, payload);

export const walletDebitSuccess = () =>
  action(balanceTypes.WALLET_DEBIT_SUCCESS);

export const walletDebitFailure = () =>
  action(balanceTypes.WALLET_DEBIT_FAILURE);

// Balance Type
export const changeBalanceType = (payload: {
  balanceType: balanceTypeInterface[];
}) => action(balanceTypes.CHANGE_BALANCE_TYPE, payload);
